import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import StatusPage from '../components/StatusPage';
import { LAST_ORDER_STORAGE_KEY } from '../components/CheckoutButton';
import { trackEvent } from '../utils/analytics';

export default function Success() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let order;
    try {
      const stored = sessionStorage.getItem(LAST_ORDER_STORAGE_KEY);
      order = stored ? JSON.parse(stored) : null;
    } catch {
      order = null;
    }

    if (order) {
      // Mercado Pago appends payment_id (or collection_id on older
      // integrations) to the success back_url; fall back to a timestamp
      // if someone lands here without those (e.g. a direct visit).
      const transactionId =
        searchParams.get('payment_id') || searchParams.get('collection_id') || `${Date.now()}`;

      trackEvent('purchase', {
        transaction_id: transactionId,
        ...order,
      });
      sessionStorage.removeItem(LAST_ORDER_STORAGE_KEY);
    }
  }, [searchParams]);

  return (
    <StatusPage
      variant="success"
      icon="🎉"
      title="¡Pago exitoso!"
      message="Gracias por tu compra. Te enviaremos un email de confirmación en breve."
    />
  );
}
